enum PhoneTypeId {
    Home = 1,
    Work = 2,
    Cell = 3,
}

export default PhoneTypeId;
